import callApi from "./callApi";

export default {
	...callApi,
	setChange: ({commit}, payload) => {
		commit("setChange", payload);
	},
	resetResponse: ({commit}) => {
		commit("resetResponse");
	},
	setFetching: ({commit}, payload) => {
		commit("setFetching", payload);
	},
	resetPagination: ({commit}) => {
		commit("resetPagination");
	},
	toogleDisplayCard: ({commit}, payload) => {
		commit("toogleDisplayCard", payload);
	},
	setLoadMore: ({commit}, payload) => {
		commit("setLoadMore", payload);
	},
	setLastItemToView: ({commit}, payload) => {
		commit("setLastItemToView", payload);
	},
	toggleItem: ({commit}, payload) => {
		commit("toggleItem", payload);
	},
	toggleCheckParent: ({commit}, payload) => {
		commit("toggleCheckParent", payload);
	},

	toggleExporting: ({commit}, payload) => {
		commit("setExporting", payload);
	},
	minimizedExport: ({commit}, payload) => {
		commit("setMinimizedExport", payload);
	},
	exportProgress: ({commit}, payload) => {
		commit("setExportProgress", payload);
	},
	multipleExport: ({commit}, payload) => {
		commit("setMultipleExport", payload);
	},
	setExportData: ({commit}, payload) => {
		commit("setExportData", payload);
	},
	setExportDataLength: ({commit}, payload) => {
		commit("setExportDataLength", payload);
	},
	resetsetListSettlementEdc: ({commit}) => {
		commit("resetsetListSettlementEdc");
	},
};
